module.exports = __webpack_public_path__ + "img/logo-8-light.69b0744a.png";